import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackgroundPattern = _resolveComponent("BackgroundPattern")!
  const _component_SectionSpacerBar = _resolveComponent("SectionSpacerBar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["klimaheld-container", _ctx.background])
  }, [
    (_ctx.points !== 'none')
      ? (_openBlock(), _createBlock(_component_BackgroundPattern, { key: 0 }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.spacer)
      ? (_openBlock(), _createBlock(_component_SectionSpacerBar, {
          key: 1,
          align: _ctx.spacerBarAlign
        }, null, 8, ["align"]))
      : _createCommentVNode("", true)
  ], 2))
}